import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classes from './Gdpr.module.css'

const Consent = (props) => {

  const { lang } = useParams();
  const { i18n } = useTranslation();
  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [i18n, lang]);

  return (
    <div className={classes.gdpr}>
        <h4 className={classes.gdpr__header}>{props.onTranslate('gdpr__header')}</h4>
        <p className={classes.gdpr__text}>{props.onTranslate('gdpr__text')}</p>
        <ol className={classes.gdpr__text}>
            <li>{props.onTranslate('gdpr__list1')}</li>
            <li>{props.onTranslate('gdpr__list2')}</li>
            <li>{props.onTranslate('gdpr__list3')}</li>
            <li>{props.onTranslate('gdpr__list4')}</li>
            <li>{props.onTranslate('gdpr__list5')}
                <ul>
                    <li>{props.onTranslate('gdpr__ul_list1')}</li>
                    <li>{props.onTranslate('gdpr__ul_list2')}</li>
                    <li>{props.onTranslate('gdpr__ul_list3')}</li>
                    <li>{props.onTranslate('gdpr__ul_list4')}</li>
                </ul>
            </li>
            <li>{props.onTranslate('gdpr__list6')}</li>
            <li>{props.onTranslate('gdpr__list7')}</li>
        </ol>
    </div>
  )
}

export default Consent